import { render, staticRenderFns } from "./MyNeofintechRequestDetail.vue?vue&type=template&id=4d71c8ab&scoped=true&"
import script from "./MyNeofintechRequestDetail.vue?vue&type=script&lang=js&"
export * from "./MyNeofintechRequestDetail.vue?vue&type=script&lang=js&"
import style0 from "./MyNeofintechRequestDetail.vue?vue&type=style&index=0&id=4d71c8ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d71c8ab",
  null
  
)

export default component.exports